"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultOptionElement = void 0;
exports.createComboBoxStandardOption = createComboBoxStandardOption;
const react_1 = __importDefault(require("react"));
const option_element_1 = require("./option-element");
const defaultOptionElement = (props) => (react_1.default.createElement(option_element_1.OptionElement, Object.assign({}, props, { style: {
        color: props.isItemValid ? "rgb(131, 131, 131)" : "red",
        minHeight: "18px",
        alignSelf: "center",
        border: "0px none rgb(131, 131, 131)",
        font: "normal normal 300 normal 15px / 30px Helvetica, Arial, sans-serif",
        outline: "rgb(131, 131, 131) none 0px"
    } })));
exports.defaultOptionElement = defaultOptionElement;
function createComboBoxStandardOption({ OptionElement = exports.defaultOptionElement }) {
    return function ComboBoxStandardOption({ value, toolTip, label, isItemValid }) {
        return (react_1.default.createElement(OptionElement, { key: `${label}-${value}`, value: value, title: toolTip, isItemValid: isItemValid }, (isItemValid ? "" : "✘ ") + label));
    };
}
//# sourceMappingURL=combo-box-standard-option.js.map